import { createContext } from 'react';

/**
 * The access this tab's page was loaded for. The shell follows a demo-mode change at once.
 * The page follows at once when the change was made in this tab, and otherwise only when the
 * user reloads it, so a change made in another tab never discards unsaved work.
 */
export interface PageAccess {
  /** The demo mode the page and its project were loaded for. */
  readonly pageDemoMode: boolean;
  /** Demo mode changed in another tab; the page still shows what it loaded before. */
  readonly pageIsStale: boolean;
  /** Changes demo mode from this tab, and has this tab's page follow once it lands. */
  readonly setDemoModeHere: (enabled: boolean) => Promise<void>;
  /** Loads the page again for the current access. */
  readonly reloadPage: () => void;
}

export const PageAccessCtx = createContext<PageAccess | null>(null);
